<script>
/* eslint-disable */

import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  data() {
    return {
      options: {
        legend: {
          // display: false,
          position: 'bottom',
        },
        tooltips: {
          enabled: true,
          callbacks: {
            title: (item, data) => data.datasets[item[0].datasetIndex].label,
            label: item => `${item.yLabel} kg CO2-eq/tonne DM`,
          },
        },
        hover: {
          mode: null,
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                fontFamily: "'Roboto Condensed', sans-serif",
                fontSize: 14,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'kg CO2-eq/tonne DM processed',
                fontSize: 18,
                fontFamily: "'Roboto Condensed', sans-serif",
              },
            },
          ],
        },
      },
    };
  },
  props: ['data'],
  mounted() {
    this.createChart();
  },
  computed: {},
  methods: {
    createChart() {
      this.renderChart(this.data, this.options);
    },
  },
};
</script>
